var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 13.5c-.412 0-.765-.147-1.059-.44a1.444 1.444 0 01-.44-1.06c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44.412 0 .765.147 1.06.44.293.294.44.648.44 1.06 0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44zm5.77 0c-.412 0-.766-.147-1.06-.44A1.444 1.444 0 0110.5 12c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44.412 0 .766.147 1.06.44.293.294.44.648.44 1.06 0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44zm5.77 0c-.413 0-.766-.147-1.06-.44a1.444 1.444 0 01-.44-1.06c0-.412.146-.766.44-1.06.294-.293.647-.44 1.06-.44.412 0 .765.147 1.058.44.294.294.441.648.441 1.06 0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44z",
    fill: "currentColor"
  })));
}
SvgEllipsis.displayName = 'Ellipsis';
export default SvgEllipsis;